import {User01Icon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'
import {AgendaSidebarSearchList} from '@/features/agenda/components/agenda-sidebar-search/AgendaSidebarSearchList'
import {usePatients} from '@/features/patients/services/usePatients'
import {ComboboxItem} from '@/components/ui/combobox-atoms/ComboboxAtoms'

interface AgendaSidebarSearchPatientsListProps {
    search?: string
    isQueryEnabled: boolean
}

export const AgendaSidebarSearchPatientsList = ({search, isQueryEnabled}: AgendaSidebarSearchPatientsListProps) => {
    const {t} = useTranslation()
    const {
        data: patients,
        isLoading,
        isError
    } = usePatients(
        {
            search,
            page: 1,
            limit: 5
        },
        undefined,
        {
            enabled: isQueryEnabled
        }
    )

    return (
        <AgendaSidebarSearchList
            isLoading={isLoading}
            isError={isError}
            items={patients?.data}
            icon={<User01Icon size={15} />}
            labelText={t('commons:patients')}
            renderItem={patient => (
                <ComboboxItem
                    hasItemCheckbox
                    key={patient.id}
                    value={patient.id}
                    data-value={patient.id}
                    data-source="patients"
                    data-name={patient.fullName}
                >
                    {patient.fullName}
                </ComboboxItem>
            )}
        />
    )
}
